<template>
    <div>
        <label :for="name" class="block text-sm text-white font-medium">{{ label }}</label>
        <div class="mt-1">
            <select ref="select" :name="name" :id="name" :disabled="disabled" :required="required"
                class="mt-1 block w-full pl-3 pr-10 text-gray-600 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-lg rounded-md py-3"
                v-model="value"
                @change="$emit('update:modelValue', value)">
                    <option v-for="option in options" :key="option">{{ option }}</option>
            </select>
            <input v-if="disabled" type="hidden" :name="name" v-model="value">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            value: null,
        };
    },
    props: {
        modelValue: { required: false },
        label: { required: false, type: String },
        name: { required: false, type: String },
        disabled: { required: false, default: false },
        options: { required: true },
        required: { default: true },
    },
    mounted() {
        if (this.required) { [this.value] = this.options; }
    },
};
</script>
